// extracted by mini-css-extract-plugin
export default {"horizontalRule":"HorizontalRule_horizontalRule__lom2F"};